//Competences.js
import React from 'react';
import Skills from '../components/Skills';
import '../assets/style/Skills.css';

const SkillsPage = () => {
  return (
    <div className="sections">
      <Skills />
    </div>
  );
};

export default SkillsPage;
